import { useEffect } from 'react'
import { connect } from 'react-redux'
import { defineMessages, FormattedMessage } from 'react-intl'
import store from 'store2'
import { createUrl } from '../../localized-urls'
import { convertCurrency } from '../helpers/PriceConverter'
import CertificationCard from '../checkout/CertificationCard'
import { trackGA4Ecommerce } from '../../gtm'
import PropTypes from 'prop-types'

const messages = defineMessages({
  confirmed: {
    id: 'order.success.screen.title',
    defaultMessage: 'Order Confirmed',
  },
  bookingNumber: {
    id: 'order.success.screen.bookingNumber',
    defaultMessage: 'Booking Number:',
  },
  emailInfo: {
    id: 'order.success.screen.emailInfo',
    defaultMessage:
      'Thanks for booking with PADI Travel. Your order confirmation, as well as your voucher will be sent to',
  },
})

function CheckoutSuccess({
  email,
  reference,
  isWidget,
  selectedCurrency,
  totalPrice,
}) {
  useEffect(() => {
    const ecommerceProducts = store.session.get('ga4Ecommerce')
    if(ecommerceProducts) {
      trackGA4Ecommerce(
        'purchase',
        {
          ...ecommerceProducts,
          transaction_id: reference,
          payment_type: 'Card',
          shipping: 0,
          tax: 0,
          value: Number(convertCurrency(totalPrice, selectedCurrency, 'USD').toFixed(2)),
          currency: 'USD',
        },
        'PADI Travel - Adventures',
      )
      store.session.remove('ga4Ecommerce')
    }
  }, [])
  return (
    <div className='congrats shadow-block'>
      <CertificationCard />
      <h2>
        <FormattedMessage {...messages.confirmed} />
      </h2>
      <div className='order-reference'>
        <p>
          <FormattedMessage {...messages.bookingNumber} />
        </p>
        <span className='reference-id'>{reference}</span>
      </div>
      <p className='mtm'>
        <FormattedMessage {...messages.emailInfo} /> - {email}
      </p>
      {!isWidget && (
        <p className='text-center'>
          <a className='btn-red small-btn' href={createUrl('homepage')}>
            <FormattedMessage
              id='back_to_homepage'
              defaultMessage='Back to the homepage'
            />
          </a>
        </p>
      )}
    </div>
  )
}

const mapStateToProps = ({ selectedCurrency, totalPrice }) => ({
  selectedCurrency,
  totalPrice: convertCurrency(
    totalPrice.value,
    totalPrice.currency,
    selectedCurrency,
    false,
    true,
  ).toFixed(2),
})

export default connect(mapStateToProps)(CheckoutSuccess)

CheckoutSuccess.propTypes = {
  email: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  isWidget: PropTypes.bool.isRequired,
  selectedCurrency: PropTypes.string.isRequired,
  totalPrice: PropTypes.number.isRequired,
}
